export default __webpack_public_path__ + "static/media/profile.39586b6c.svg";